import React from "react";
import paths from "./public-routes.json";
import VoorbereidingDefensie from "../pages/VoorbereidingDefensie";
import Cluster6VoorbereidingVrouwen from "../pages/Cluster6VoorbereidingVrouwen";
import Mariniers from "../pages/units/Mariniers";
import PageWrapper from "../components/PageWrapper";
import Home from "../pages/Home";
import VoorbereidingVeiligheidsdiensten from "../pages/VoorbereidingVeiligheidsdiensten";
import CommandoTroepen from "../pages/units/KorpsCommandoTroepen";
import Luchtmobiel from "../pages/units/LuchtmobieleBrigade";
import Veiligheidsdiensten from "../pages/units/veiligheidsdiensten";
import Program from "../pages/Program";
import ProgrammaVeiligheidsdiensten from "../pages/ProgrammaVeiligheidsdiensten";
import Pricing from "../pages/Pricing";
import About from "../pages/About";
import Ervaringen from "../pages/Ervaringen";
import Contact from "../pages/Contact";
import PreparationCheckLanding from "../pages/PreparationCheckLanding";
import Legal from "../pages/Legal";

// These are the real page components, shared by the browser and build renderer.
const pages = {
  "/voorbereiding-defensie": <VoorbereidingDefensie />,
  "/cluster-6-voorbereiding-vrouwen": <Cluster6VoorbereidingVrouwen />,
  "/units/mariniers": (
    <PageWrapper animateOnMount={false}><Mariniers /></PageWrapper>
  ),
  "/": <Home animateOnMount={false} />,
  "/voorbereiding-veiligheidsdiensten": <VoorbereidingVeiligheidsdiensten />,
  "/units/commandotroepen": <PageWrapper animateOnMount={false}><CommandoTroepen /></PageWrapper>,
  "/units/luchtmobiel": <PageWrapper animateOnMount={false}><Luchtmobiel /></PageWrapper>,
  "/units/veiligheidsdiensten": <PageWrapper animateOnMount={false}><Veiligheidsdiensten /></PageWrapper>,
  "/program": <Program />,
  "/programma-veiligheidsdiensten": <ProgrammaVeiligheidsdiensten />,
  "/pricing": <Pricing animateOnMount={false} />,
  "/about": <About />,
  "/ervaringen": <Ervaringen />,
  "/contact": <Contact />,
  "/voorbereiding-check": <PreparationCheckLanding />,
  "/legal": <Legal />,
};

export const publicPrerenderRoutes = paths.map((path) => ({
  path,
  element: pages[path],
}));
